import { PageEntityAccounts } from './Accounts';
import { PageEntitiesEdit } from './Edit';
import { PageEntities } from './Overview';
import { PageRootEntity } from './RootEntity';
import { PageRootEntityAccounts } from './RootEntityAccounts';
import { PageRootEntityRedirect, PageRootEntitySection } from './RootEntitySection';
import { PageEntitySection } from './Section';

export const ENTITIES = {
  Entities: PageEntities,
  EntityAccounts: PageEntityAccounts,
  EntitySection: PageEntitySection,
  EntitiesEdit: PageEntitiesEdit,
  RootEntity: PageRootEntity,
  RootEntityAccounts: PageRootEntityAccounts,
  RootEntityRedirect: PageRootEntityRedirect,
  RootEntitySection: PageRootEntitySection,
} as const;
